import React from 'react'

// Style sheet
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/pageBanner.scss'

// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Icon
import { FaCloudSunRain, FaWater, FaSolarPanel } from 'react-icons/fa';
import { FcAbout } from "react-icons/fc";
import { SiAboutdotme } from "react-icons/si";
import { BsInfoCircle } from "react-icons/bs";
//
function pageBannerIcon_ChooseIcon(icon_input: string) {
  switch(icon_input) { 
    case "FaCloudSunRain": { 
       return <FaCloudSunRain size={90}/>;
    }
    case "FcAbout": {
       return <FcAbout size={90} color='red'/>;
    }
    case "SiAboutdotme": {
       return <SiAboutdotme size={90}/>;
    }
    case "BsInfoCircle": {
      return <BsInfoCircle size={90}/>; 
    }
    case "FaWater": {
      return <FaWater size={90}/>; 
    }
    case "faSolarPanel": {
      return <FaSolarPanel size={90}/>; 
    }
    default: { 
       break; 
    } 
 } 
}

type Props = {title:string, description:string, icon:string, id:string}

function pageBanner({title, description, icon, id}: Props) {
  return (
    <div id={id} className='pageBanner'>
      <Container style={{ padding: 12 }}>
        <Row>
            <Col sm={12} md={8} lg={8}>
                <Row>
                    <h1>{title}</h1>
                </Row>
                <Row>
                    <h5>{description}</h5>
                </Row>
            </Col>
                
            <Col sm={0} md={4} lg={4}>
                <div className="pageBannerIcon">
                  { pageBannerIcon_ChooseIcon(icon) }
                </div>
            </Col>
        </Row>
      </Container>

    </div>
  )
}

export default pageBanner;